exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sideBarMenuContainer {\n\tposition: fixed;\n\toverflow-y: scroll;\n\toverflow-x: hidden;\n\theight: 100vh;\n\twidth: 250px;\n\tbackground-color: #ffffff;\n\tbox-shadow: 2px 0 6px 0 rgba(0, 0, 0, 0.08);\n\tz-index: 10;\n}\n", ""]);

// exports
